export default __webpack_public_path__ + "static/media/img3.8c481935.png";